import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import BannerAlert from "@/components/wpl/banner-alert/src";
import { cssReset } from "@/libraries/wpl/foundations/src";
import GlobalFooter from "@/patterns/global-footer/src/index";

import CTASectionPaidLpJswFeatures from "./sections/cta";
import HeroSectionPaidLpJswFeatures from "./sections/hero";
import SideBySideAlternatingImageAndTextSectionPaidLpJswFeatures from "./sections/sideBySideAlternatingImageAndTextSection";
import SocialProofPaidLpJswFeatures from "./sections/social-proof";
import JiraSoftwareNavPaidLpJswFeatures from "./sections/software-jira-navbar";
import Tabs from "./sections/tabs/index";

export const JiraSoftwarePageTemplatePaidLpJswFeatures = () => {
    const intl = useIntl();

    const bannerMessages = {
        identifier: "jira-software.banner-alert.atlassian-intelligence",
        text: intl.formatMessage({
            id: "jira-software.banner-alert.text",
            defaultMessage:
                "Get early access to Atlassian Intelligence, your new virtual teammate that deeply understands how teams collaborate to accelerate work."
        }),
        linkText: intl.formatMessage({
            id: "jira-software.banner-alert.link-text",
            defaultMessage: "Learn more"
        }),
        linkUrl: useLocalizedHref("/software/artificial-intelligence")
    };

    return (
        <div css={cssReset}>
            <JiraSoftwareNavPaidLpJswFeatures />
            <BannerAlert
                identifier={bannerMessages.identifier}
                text={bannerMessages.text}
                linkUrl={bannerMessages.linkUrl}
                linkText={bannerMessages.linkText}
            />
            <HeroSectionPaidLpJswFeatures />
            <Tabs />
            <SideBySideAlternatingImageAndTextSectionPaidLpJswFeatures />
            <CTASectionPaidLpJswFeatures />
            <SocialProofPaidLpJswFeatures />
            <GlobalFooter />
        </div>
    );
};
